import { gql } from '@apollo/client';

/**
 * 读取 common_config 表 TIKTOK_SORT_CENTER_HUB_MAPPING 里所有映射：
 * sortCenterCode + warehouseId + warehouseName（由后端 join warehouse 表得到）。
 * 用于包牌列表分拣码筛选下拉里 TT 分支的 seg1 候选，展示 "sortCenterCode - warehouseName"。
 * 配置缺失/空/解析失败均返回 []。
 */
export const GET_TIKTOK_SORT_CENTER_MAPPINGS = gql`
    query GetTikTokSortCenterMappings {
        getTikTokSortCenterMappings {
            sortCenterCode
            warehouseId
            warehouseName
        }
    }
`;

export interface TikTokSortCenterMapping {
    sortCenterCode: string;
    warehouseId: string;
    warehouseName: string | null;
}

export interface GetTikTokSortCenterMappingsResponse {
    getTikTokSortCenterMappings: TikTokSortCenterMapping[];
}
